export const environment = {
  production: true,
  token: '',
  nome: '',
  id: 0,
  foto: '',
  server: 'https://apirepassa.herokuapp.com'
};

//'http://apirepassa.herokuapp.com'
//'http://localhost:8080'
